import { createFileRoute } from "@tanstack/react-router";

import { PageHero } from "@/components/site/PageHero";
import { SiteFooter } from "@/components/site/SiteFooter";
import { TeamSection, TeamSupportSection } from "@/components/site/sections";

export const Route = createFileRoute("/team")({
  head: () => ({
    meta: [
      { title: "Meet the Founder — adaptED" },
      {
        name: "description",
        content: "Meet Atoofah Gierdien, the founder building adaptED — safe, learning-first AI for South African learners.",
      },
      { property: "og:title", content: "Meet the Founder — adaptED" },
      { property: "og:description", content: "The founder-led story behind adaptED." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://www.adapted.info/team" },
      { property: "og:site_name", content: "adaptED" },
      { name: "twitter:title", content: "Meet the Founder — adaptED" },
      { name: "twitter:description", content: "The founder-led story behind adaptED." },
    ],
    links: [{ rel: "canonical", href: "https://www.adapted.info/team" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "@id": "https://www.adapted.info/#organization",
          name: "adaptED",
          url: "https://www.adapted.info/",
          employee: [
            {
              "@type": "Person",
              name: "Atoofah Gierdien",
              jobTitle: "Chief Executive Officer",
              worksFor: { "@id": "https://www.adapted.info/#organization" },
              sameAs: ["https://www.linkedin.com/in/atoofah-gierdien"],
            },
          ],
        }),
      },
    ],
  }),
  component: TeamPage,
});

function TeamPage() {
  return (
    <main id="top">
      <PageHero
        label=""
        title="Meet the Founder"
        paragraph="Founder-led, mission-driven. Atoofah Gierdien brings deep classroom insight, research discipline and a stubborn belief that every South African learner can move forward with confidence. That's the work she leads at adaptED."
      />
      <TeamSection />
      <TeamSupportSection />
      <SiteFooter />
    </main>
  );
}
